import { render } from "./BusinessInfo.vue?vue&type=template&id=3dae8ee2&scoped=true"
import script from "./BusinessInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInfo.vue?vue&type=script&lang=js"

import "./BusinessInfo.vue?vue&type=style&index=0&id=3dae8ee2&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dae8ee2"]])

export default __exports__